// Usta kartochkasi uchun yagona o'qish: backend (adminProviderExtras) maydonlari
// `region` / `district` (regionName / districtName bilan bir xil), `categories: [{id,name}]`,
// `imageUrl` (mutlaq https yoki null).
export const providerRegion = (p) =>
  p ? [p.region ?? p.regionName, p.district ?? p.districtName].filter(Boolean).join(', ') : '';

export const providerCategories = (p) =>
  p && Array.isArray(p.categories) ? p.categories.filter((c) => c && c.name) : [];

export const providerImage = (p) => (p && (p.imageUrl || p.photoUrl)) || null;
